import React, {
    useEffect,
    useState,
    useLayoutEffect,
    useCallback,
    UIEvent,
} from 'react'

import OutlinedInput from '../../components/outlinedInput/OutlinedInput'
import Text from '../../components/text/Text'
import ModalComponent from '../../components/modal/ModalComponent'
import SuccessModal from '../../components/modal/modalVariants/SuccessModal'
import ErrorModal from '../../components/modal/modalVariants/ErrorModal'
import { VARIANTS, VariantsType } from '../../components/modal/ModalComponent'
import { clevertapEvents, labels } from '../../labels'
import {
    localCategoriesCommerce,
    localProducts,
    getProducts,
    liquidateFromStock,
    stopLiquidatedProduct,
} from '../../services/products'
import './Inventory.css'
import NavBarCategories from '../../components/navigation/NavBarCategories'
import TableInventory from '../../components/tables/TableInventory'
import useDate from '../../hooks/useDate'
import Calendar from '../../components/calendar/Calendar'
import CardProduct, { lastId } from '../../components/cards/CardProduct'
import iconError from '../../assets/icons/icons-error-msj.svg'
import LiquidateError from '../../components/modal/modalVariants/LiquidateError'
import { track } from '../../ClevertapWrapper'
import { format } from 'date-fns'
import routes from '../../router/routes'
import { useNavigate } from 'react-router-dom'
import ProductType from '../../components/productType/ProductType'
import { getLocal, isAdmin } from '../../Utils/Profile'
import { DeleteProduct } from '../product/deleteProduct/DeleteProduct'
import ImageComida from '../../assets/images/comida.png'

export default function Inventory() {
    const navigate = useNavigate()
    const [category, setCategory] = useState<string>('')
    const [nameProduct, setNameProduct] = useState<string>('')
    const [page, setPage] = useState<number>(1)
    const [filter, setFilter] = useState<string>('')
    const [listProducts, setListProducts] = useState<IProductsWithPage>()
    const [listProductsFiltered, setListProductsFiltered] =
        useState<IProductsWithPage>()
    const [listCategories, setListCategories] = useState<ICategory[]>([])

    const [refresh, setRefresh] = useState<boolean>(false)
    const [sortName, setSortName] = useState<string>('asc')
    const [sortPrice, setSortPrice] = useState<string>('')

    const [fetch, setFetch] = useState<boolean>(false)
    const [currentCategory, setCurrentCategory] = useState<string>('ALL')

    const [showModalLiquidate, setShowModalLiquidate] = useState<boolean>(false)
    const [productLiq, setProductLiq] = useState<IProductObject>()

    const [showModalView, setShowModalView] = useState<boolean>(false)

    const [modalContentType, setModalContentType] = useState<VariantsType>(null)
    const [modalContentTypeStopLiq, setModalContentTypeStopLiq] =
        useState<VariantsType>(null)
    const [noData, setNoData] = useState<boolean>(false)

    const [inputPrice, setInputPrice] = useState<number>(0)
    const [inputStock, setInputStock] = useState<number>(0)

    const [showErrorPrice, setShowErrorPrice] = useState<boolean>(false)
    const [showErrorStock, setShowErrorStock] = useState<boolean>(false)
    const [showErrorDate, setShowErrorDate] = useState<boolean>(false)
    const [minWidth, setMinWidth] = useState(
        window.matchMedia('(min-width: 749px)').matches
    )
    const [liquidar, setLiquidar] = useState<boolean>(false)
    const pageSize = 6

    const [lat, setLat] = useState<number>(0)
    const [lng, setLng] = useState<number>(0)

    const [selectedDeleteProduct, setSelectedDeleteProduct] =
        useState<IProductObject>()

    const [viewProductInfo, setViewProductInfo] = useState({
        food: true,
        name: '',
        description: '',
        shortDescription: '',
        brand: '',
        classification: '',
        image: '',
        unitOfMeasure: '',
        quantityPerUM: -1,
        price: -1,
        stock: -1,
    })

    const currentUser = localStorage.getItem('currentUser') || '{}'
    const user = currentUser && JSON.parse(currentUser)

    const clevertapData = {
        geoLocationLat: lat,
        geoLocationLong: lng,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        // ID: commerceId
    }
    const pageLoadData = {
        pageName: 'Inventario',
        pageURL: routes.inventory,
        geoLocationLat: lat,
        geoLocationLong: lng,
        date: format(new Date(), 'yyyy/MM/dd'),
        hour: format(new Date(), 'kk:mm:ss'),
        codComercio: user?.sEstablecimiento,
        codLocal: getLocal(),
    }
    const getLocation = () => {
        navigator.geolocation.getCurrentPosition((position) => {
            setLat(position.coords.latitude)
            setLng(position.coords.longitude)
        })
    }

    const fillData = (newData: IProductObject) => {
        navigate('edit', { state: newData })
    }

    const handleCloseModalStopLiq = () => {
        setModalContentTypeStopLiq(null)
        setRefresh(true)
    }

    const handleCloseModalLiquidate = () => {
        setShowModalLiquidate(false)
    }

    const getFilterProducts = async () => {
        await getProducts(
            filter,
            page,
            pageSize,
            category,
            nameProduct,
            sortName,
            sortPrice
        )

        setFetch(false)
    }

    const onScroll = useCallback(
        (event: UIEvent<HTMLDivElement>) => {
            const last = document
                .getElementById(lastId)
                ?.getBoundingClientRect()
            if (document.body.getBoundingClientRect().width < 769) {
                if (last && last?.top < 1300 && !fetch && !noData) {
                    setFetch(true)
                    event.preventDefault()
                    event.stopPropagation()

                    setPage(page + 1)
                }
            }
        },
        [fetch, page]
    )

    const handleSearchChange = (data: React.FormEvent<HTMLInputElement>) => {
        if (data.currentTarget.value != null) {
            track(clevertapEvents.inventoryClickSearch, clevertapData)
            setNameProduct(data.currentTarget.value)
            setPage(1)
            setNoData(false)
        }
    }

    const onChangePage = (page: number) => {
        setPage(page)
    }

    const handleClickItemNav = (data: string) => {
        if (data === 'ALL') {
            setCategory('')
            setFilter('')
        } else if (data.includes('liquidacion')) {
            setCategory('')
            setFilter('SETTLEMENT')
        } else if (data.includes('promocion')) {
            setCategory('')
            setFilter('PROMOTION')
        } else if (data.includes('inperson')) {
            setCategory('')
            setFilter('F2F')
        } else if (data.includes('online')) {
            setCategory('')
            setFilter('ONLINE')
        } else {
            setCategory(data)
            setFilter('')
        }
        setCurrentCategory(data)

        setListProductsFiltered(undefined)
        setPage(1)
        setNoData(false)
    }

    const onLiquidate = async (product: IProductObject) => {
        const data = {
            geoLocationLat: lat,
            geoLocationLong: lng,
            date: format(new Date(), 'yyyy/MM/dd'),
            hour: format(new Date(), 'kk:mm:ss'),
            productName: product.product.productName,
        }
        track(clevertapEvents.inventoryLiquidateProductButton, data)
        setProductLiq(product)
        setLiquidar(false)
        setShowErrorDate(false)
        setShowErrorPrice(false)
        setShowErrorStock(false)
        setInputPrice(0)
        setInputStock(0)
        setShowModalLiquidate(true)
    }

    const onDeleteProduct = async (product: IProductObject) => {
        setSelectedDeleteProduct(product)
    }

    const onDeleteCancelProduct = async () => {
        setSelectedDeleteProduct(undefined)
    }

    const onDeleteSuccessProduct = async () => {
        setSelectedDeleteProduct(undefined)
        if (page > 1) {
            if (!listProductsFiltered?.products) {
                setPage(1)
            } else {
                if (listProductsFiltered.products.length === 1) {
                    setPage(1)
                }
            }
        } else {
            setRefresh(true)
        }
    }

    const onView = async (product: IProductObject) => {
        const viewProduct = {
            food: product.product.food || false,
            name: product.product.productName,
            description: product.product.fullDescription,
            shortDescription: product.product.shortDescription,
            brand: product.productBrand.name,
            classification: product.productCategories.name,
            image: product.product.photoURL,
            unitOfMeasure: product.product.productMeasureUnit,
            quantityPerUM: product.product.weight,
            price: product.productPrices[0].saleAmount,
            stock: Number(product.commerceStock.stock),
        }

        setViewProductInfo(viewProduct)
        setShowModalView(true)
    }

    const handleCloseModalView = () => {
        setShowModalView(false)
    }

    const onStopLiquidating = async (product: IProduct) => {
        const res = await stopLiquidatedProduct(product.id)
        if (res.status === 200) {
            setModalContentTypeStopLiq(VARIANTS.SUCCESS)
        } else {
            setModalContentTypeStopLiq(VARIANTS.ERROR)
        }
    }

    const { handleDate, selectedDate } = useDate(new Date())

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault()
        const data = new FormData(event.currentTarget)

        const price = Number(data.get('liquidatePrice'))
        const stock = Number(data.get('liquidateStock'))

        const res = await liquidateFromStock({
            commerceInternalID: productLiq
                ? productLiq.product.commerceCreatedBy
                : 0,
            dateVoidSettlement: selectedDate,
            saleAmount: price,
            sku: productLiq ? productLiq.product.sku : '',
            stock: stock,
        })

        if (res.status === 200) {
            setModalContentType(VARIANTS.SUCCESS)
        } else {
            setModalContentType(VARIANTS.ERROR)
        }
    }

    const handleChangePrice = (data: React.FormEvent<HTMLInputElement>) => {
        const price = data.currentTarget.value
        setInputPrice(Number(data.currentTarget.value))
        const priceProduct = productLiq?.productPrices[0]
            ? productLiq?.productPrices[0].saleAmount
            : 0

        if (Number(price) > 0) {
            if (Number(price) < priceProduct) {
                setShowErrorPrice(false)
            } else if (Number(price) >= priceProduct) {
                setShowErrorPrice(true)
            }
        }
    }

    const handleChangeStock = (data: React.FormEvent<HTMLInputElement>) => {
        const stock = data.currentTarget.value
        setInputStock(Number(data.currentTarget.value))
        const stockProduct = productLiq?.commerceStock
            ? productLiq?.commerceStock.stock
            : 0

        if (Number(stock) > 0) {
            if (Number(stock) <= stockProduct) {
                setShowErrorStock(false)
            } else if (Number(stock) > stockProduct) {
                setShowErrorStock(true)
            }
        }
    }

    const onSort = (item: string) => {
        if (item === 'Descripción') {
            setSortPrice('')
            setSortName(sortName === 'asc' ? 'desc' : 'asc')
            if (page == 1) {
                setRefresh(true)
            } else {
                setPage(1)
            }
        }
        if (item === 'Precio') {
            setSortName('')
            setSortPrice(sortPrice === 'asc' ? 'desc' : 'asc')
            if (page == 1) {
                setRefresh(true)
            } else {
                setPage(1)
            }
        }
    }

    const titles = [
        'Imagen',
        'Nombre del producto',
        'EAN',
        'Precio',
        'Stock',
        'Disponible en',
        'Acciones',
    ]

    useEffect(() => {
        window
            .matchMedia('(min-width: 749px)')
            .addEventListener('change', (e) => setMinWidth(e.matches))
    }, [])

    useLayoutEffect(() => {
        const resize = () => {
            if (document.body.getBoundingClientRect().width < 769) {
                setPage(1)

                setNoData(false)
            }
        }
        window.addEventListener('resize', resize)
        return () => window.removeEventListener('resize', resize)
    }, [])

    useEffect(() => {
        const init = async () => {
            await getFilterProducts()
            setListProducts(localProducts)
            setListCategories(localCategoriesCommerce)
        }

        init()
    }, [])

    useEffect(() => {
        const init = async () => {
            await getFilterProducts()
            setListProductsFiltered(localProducts)
        }

        if (refresh) {
            init()
            setRefresh(false)
        }
    }, [refresh])

    useEffect(() => {
        const filter = async () => {
            await getFilterProducts().then(() => {
                setListProductsFiltered((prevState) => {
                    const newProducts = localProducts()

                    if (newProducts.products.length > 0) {
                        if (page === 1 || minWidth) {
                            return newProducts
                        }
                        if (prevState) {
                            return {
                                pages: newProducts.pages,
                                products: [
                                    ...prevState.products,
                                    ...newProducts.products,
                                ],
                            }
                        }
                    } else {
                        if (nameProduct.length > 0) {
                            setNoData(false)
                            return newProducts
                        } else {
                            setNoData(true)
                            return prevState
                        }
                    }
                })
                setFetch(false)
            })
        }
        if (!noData) {
            filter()
        }
    }, [category, nameProduct, page, filter, noData])
    useEffect(() => {
        const validate = () => {
            let validPrice = true
            let validStock = true

            const normalPrice = Number(productLiq?.productPrices[0].saleAmount)
            const normalStock = Number(productLiq?.commerceStock.stock)

            validPrice =
                inputPrice === 0 || (inputPrice && normalPrice < inputPrice)
                    ? false
                    : true
            validStock =
                inputStock === 0 || (inputStock && normalStock < inputStock)
                    ? false
                    : true

            setLiquidar(validPrice && validStock)
        }

        validate()
    }, [inputPrice, inputStock])

    useEffect(() => {
        getLocation()
    }, [lat, lng])

    useEffect(() => {
        track(clevertapEvents.pageLoadmp, pageLoadData)
    }, [])
    useEffect(() => {
        track(clevertapEvents.pageLoadmp, pageLoadData)
    }, [])
    const handleCloseModal = () => {
        setModalContentType(null)
        setShowModalLiquidate(false)
        setRefresh(true)
    }

    if (listProducts?.products && listProducts.products.length <= 0) {
        return (
            <div className="inventory-container-no-products">
                <div className="inventory-content-no-products">
                    <Text
                        textAlign="center"
                        label="No tienes productos publicados en tu tienda."
                        fontFamily="Montserrat"
                        fontSize={24}
                        fontWeight={600}
                        color="#184287"
                    />
                    <img width={300} src={ImageComida} alt="comida" />
                    {isAdmin() ? (
                        <>
                            <Text
                                textAlign="center"
                                label="Por el momento no has publicado productos en tu tienda. Cuando los hayas cargado podrás encontrarlos aquí. -😞-🌮-🍕-🍔-🥗-"
                                fontFamily="Montserrat"
                                fontWeight={400}
                                fontSize={16}
                                color="#565656"
                            />
                            <Text
                                textAlign="center"
                                label="Sube tus productos de forma masiva o crea un producto nuevo desde “Impulsa tus ventas > Cargar productos."
                                fontFamily="Montserrat"
                                fontWeight={400}
                                fontSize={16}
                                color="#565656"
                            />
                        </>
                    ) : (
                        <Text
                            textAlign="center"
                            label="Por el momento no se han publicado productos en tu tienda. Cuando se hayan cargado los encontrarás aquí. -😞-🌮-🍕-🍔-🥗-"
                            fontFamily="Montserrat"
                            fontWeight={400}
                            fontSize={16}
                            color="#565656"
                        />
                    )}
                    {isAdmin() && (
                        <button
                            type="submit"
                            className="inventory-btn-no-products"
                            onClick={() => {
                                navigate(`/${routes.products}`)
                            }}
                        >
                            <Text
                                label="Cargar producto"
                                fontWeight={600}
                                fontSize={16}
                                fontFamily="Montserrat"
                                color="#FFF"
                            />
                        </button>
                    )}
                </div>
            </div>
        )
    }

    return (
        <>
            <ModalComponent
                show={showModalView}
                handleClose={handleCloseModalView}
                modalStyle="view-modal"
                icon={false}
            >
                <div className="view-modalContainer">
                    <div style={{ display: 'flex', marginTop: 30 }}>
                        <Text
                            label="Informacion del producto"
                            fontSize={16}
                            fontWeight={600}
                            color="#656565"
                            fontFamily="Nunito"
                        />
                        <div className="view-divider"></div>
                    </div>
                    <div
                        style={{
                            display: 'block',
                            marginTop: 10,
                            marginBottom: 30,
                        }}
                    >
                        <Text
                            label="Tipo"
                            marginBottom={5}
                            fontSize={16}
                            fontWeight={600}
                            color="#656565"
                            fontFamily="Nunito"
                        />
                        <ProductType
                            isFood={viewProductInfo.food}
                            isSwitchable={false}
                            onChange={() => console.log('')}
                        />
                    </div>
                    <div>
                        <OutlinedInput
                            floatingLabel={labels.name}
                            value={viewProductInfo.name}
                            disabled
                        />
                    </div>
                    <div className="view-row">
                        <OutlinedInput
                            floatingLabel={labels.description}
                            value={viewProductInfo.description}
                            disabled
                        />
                    </div>
                    <div className="view-row">
                        <OutlinedInput
                            floatingLabel={labels.shortDescription}
                            value={viewProductInfo.shortDescription}
                            disabled
                        />
                    </div>
                    <div className="view-row">
                        <OutlinedInput
                            floatingLabel={labels.productBrand}
                            value={viewProductInfo.brand}
                            disabled
                        />
                    </div>
                    <div className="view-row">
                        <OutlinedInput
                            floatingLabel={labels.classification}
                            value={viewProductInfo.classification}
                            disabled
                        />
                    </div>
                    <div className="view-row">
                        <Text
                            label={labels.productImage}
                            fontFamily="Nunito"
                            fontSize={13}
                            fontWeight={600}
                            color="#656565"
                        />
                    </div>
                    <div className="view-row">
                        <img src={viewProductInfo.image} width={200} />
                    </div>
                    <div style={{ display: 'flex', gap: '20px' }}>
                        <OutlinedInput
                            floatingLabel={labels.unit}
                            value={viewProductInfo.unitOfMeasure}
                            disabled
                        />
                        <OutlinedInput
                            floatingLabel={labels.quantity}
                            value={viewProductInfo.quantityPerUM.toString()}
                            disabled
                        />
                    </div>
                    <div
                        style={{ display: 'flex', gap: '20px', marginTop: 10 }}
                    >
                        <OutlinedInput
                            floatingLabel={labels.price}
                            value={viewProductInfo.price.toString()}
                            disabled
                        />
                        <OutlinedInput
                            floatingLabel={labels.stock}
                            value={viewProductInfo.stock.toString()}
                            disabled
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            marginTop: 20,
                            marginBottom: 30,
                            justifyContent: 'center',
                        }}
                    >
                        <button
                            onClick={() => setShowModalView(false)}
                            className="view-btnCerrar"
                        >
                            <Text
                                label={'Cerrar'}
                                fontWeight={600}
                                color="#ffff"
                            />
                        </button>
                    </div>
                </div>
            </ModalComponent>

            <ModalComponent
                show={showModalLiquidate}
                handleClose={handleCloseModalLiquidate}
            >
                <div className="container-body-liquidate">
                    <div className="container-title-liquidate">
                        <div className="image-product-liquidate">
                            <img
                                src={
                                    productLiq
                                        ? productLiq.product.photoURL
                                        : ''
                                }
                                width={'84px'}
                                height={'84px'}
                            />
                        </div>
                        <div className="name-product-liquidate">
                            <div>
                                <Text
                                    label={
                                        productLiq
                                            ? productLiq.product
                                                  .shortDescription
                                            : ''
                                    }
                                    variant="text-description-short"
                                />
                            </div>
                            <div>
                                <Text
                                    label={
                                        productLiq
                                            ? productLiq.product.fullDescription
                                            : ''
                                    }
                                    variant="text-description-full"
                                />
                            </div>
                        </div>
                    </div>
                    <div>
                        <form
                            className="form-liquidate"
                            onSubmit={handleSubmit}
                            noValidate
                        >
                            <div className="form-inputs">
                                <div className="input-price">
                                    <OutlinedInput
                                        formId="liquidatePrice"
                                        floatingLabel={
                                            labels.inventoryModalPrice
                                        }
                                        placeholder="Ej.: $2990"
                                        helperText={`Precio Normal: ${
                                            productLiq
                                                ? productLiq.productPrices[0]
                                                      .saleAmount
                                                : ''
                                        }`}
                                        onChange={handleChangePrice}
                                    />
                                </div>
                                <div className="input-stock">
                                    <OutlinedInput
                                        formId="liquidateStock"
                                        floatingLabel={
                                            labels.inventoryModalStock
                                        }
                                        placeholder="Ej.: 1"
                                        helperText={`Stock disponible: ${
                                            productLiq
                                                ? productLiq.commerceStock.stock
                                                : ''
                                        }`}
                                        onChange={handleChangeStock}
                                    />
                                </div>
                            </div>
                            {showErrorPrice && (
                                <div className="error-message">
                                    <img
                                        src={iconError}
                                        width={'28px'}
                                        height={'28px'}
                                    />
                                    <Text
                                        label={
                                            labels.inventoryModalMsjErrorPrice
                                        }
                                        variant="text-error-modal"
                                    />
                                </div>
                            )}
                            {showErrorStock && (
                                <div className="error-message">
                                    <img
                                        src={iconError}
                                        width={'28px'}
                                        height={'28px'}
                                    />
                                    <Text
                                        label={
                                            labels.inventoryModalMsjErrorStock
                                        }
                                        variant="text-error-modal"
                                    />
                                </div>
                            )}
                            <div>
                                <div className={'dateContainer'}>
                                    <p className="Subtitle2 leftAlign greyColorInv">
                                        {labels.inventoryModalDate}
                                    </p>
                                    <Calendar
                                        onChange={handleDate}
                                        minDate={new Date()}
                                    />
                                </div>
                            </div>
                            {showErrorDate && (
                                <div className="error-message">
                                    <img
                                        src={iconError}
                                        width={'28px'}
                                        height={'28px'}
                                    />
                                    <Text
                                        label={
                                            labels.inventoryModalMsjErrorDate
                                        }
                                        variant="text-error-modal"
                                    />
                                </div>
                            )}
                            <button
                                type="submit"
                                className="button-submit-liquidation"
                                disabled={!liquidar}
                            >
                                {labels.productsDiscountTitle}
                            </button>
                        </form>
                    </div>
                </div>
            </ModalComponent>

            <ModalComponent
                show={!!modalContentType}
                handleClose={handleCloseModal}
                modalStyle={'modalsmallInv'}
            >
                {modalContentType === VARIANTS.ERROR && (
                    <ErrorModal
                        text={labels.inventoryErrorLiquidacion}
                        buttonText={labels.continue}
                    />
                )}
                {modalContentType === VARIANTS.SUCCESS && (
                    <SuccessModal
                        text={labels.inventorySuccesLiquidacion}
                        buttonText={labels.continue}
                        handleOnPress={handleCloseModal}
                    />
                )}
            </ModalComponent>

            <ModalComponent
                show={!!modalContentTypeStopLiq}
                handleClose={handleCloseModalStopLiq}
                modalStyle={'modalsmallInv'}
            >
                {modalContentTypeStopLiq === VARIANTS.ERROR && (
                    <LiquidateError onClick={handleCloseModalStopLiq} />
                )}
                {modalContentTypeStopLiq === VARIANTS.SUCCESS && (
                    <SuccessModal
                        text={labels.inventorySuccesStopLiquidacion}
                        buttonText={labels.continue}
                        handleOnPress={handleCloseModalStopLiq}
                    />
                )}
            </ModalComponent>

            {listProducts?.products && listProducts?.products.length <= 0 ? (
                <div className="container-all-productsempty">
                    <div className="container-productsempty">
                        <div className="container-productsemptyheader">
                            <Text
                                label="No tienes productos publicados en tu tienda online"
                                fontSize={20}
                                fontWeight="bold"
                                textAlign="center"
                            />
                            <Text
                                label="☹️🌮🍕🍔🥗"
                                fontSize={20}
                                fontWeight={600}
                                textAlign="center"
                            />
                        </div>
                        <div className="container-productsemptyfooter">
                            <Text
                                label={labels.inventoryEmptyFooter}
                                fontSize={13}
                                fontWeight={600}
                                textAlign="center"
                            />
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container-body">
                    <div className="container-search-name">
                        <OutlinedInput
                            formId={'search-name'}
                            floatingLabel={labels.inventorySearch}
                            placeholder={labels.inventorySearchHolder}
                            charCounter
                            trailingIcon="search"
                            onChange={handleSearchChange}
                        />
                    </div>
                    <div className="container-navbar">
                        <NavBarCategories
                            listCategories={listCategories}
                            onClickItem={handleClickItemNav}
                            currentCategory={currentCategory}
                        />
                    </div>
                    {minWidth ? (
                        <div className="container-inventory">
                            <div className="container-table-inventory">
                                <TableInventory
                                    listProducts={
                                        listProductsFiltered
                                            ? listProductsFiltered?.products
                                            : []
                                    }
                                    listTitles={titles}
                                    liquidate={onLiquidate}
                                    onDelete={onDeleteProduct}
                                    stopLiquidating={onStopLiquidating}
                                    pageSize={pageSize}
                                    totalPage={
                                        listProductsFiltered
                                            ? listProductsFiltered.pages
                                            : 1
                                    }
                                    onUpdateClick={fillData}
                                    onPageChange={onChangePage}
                                    onSort={onSort}
                                    currentPage={page}
                                    view={onView}
                                />
                            </div>
                        </div>
                    ) : (
                        <div
                            className="container-cards-inventory"
                            onScroll={onScroll}
                        >
                            {listProductsFiltered?.products.map(
                                (item, index) => {
                                    return (
                                        <CardProduct
                                            isLast={
                                                index ===
                                                listProductsFiltered.products
                                                    .length -
                                                    1
                                            }
                                            liquidate={onLiquidate}
                                            stopLiquidating={onStopLiquidating}
                                            key={item.product.id}
                                            productObject={item}
                                            onUpdateClick={fillData}
                                        />
                                    )
                                }
                            )}
                        </div>
                    )}
                </div>
            )}
            <DeleteProduct
                product={selectedDeleteProduct}
                onCancel={onDeleteCancelProduct}
                onSuccess={onDeleteSuccessProduct}
            />
        </>
    )
}
